import type { Metadata } from "next";
import { Geist, Geist_Mono } from "next/font/google";
import { RootShell } from "@/components/root-shell";
import { NO_FOUC_SCRIPT } from "@/components/theme-provider";
import "./globals.css";

const geistSans = Geist({ variable: "--font-geist-sans", subsets: ["latin"] });
const geistMono = Geist_Mono({ variable: "--font-geist-mono", subsets: ["latin"] });

export const metadata: Metadata = {
  title: "missioflow SuperAdmin",
  description: "Panel d'administration globale du SaaS missioflow",
  // Aucune indexation possible : panel admin privé, jamais exposé publiquement
  // aux bots. Combiné avec robots.ts ci-après qui bloque tous les user-agents.
  robots: {
    index: false,
    follow: false,
    nocache: true,
    googleBot: { index: false, follow: false, noimageindex: true },
  },
};

export default function RootLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <html
      lang="fr"
      className={`${geistSans.variable} ${geistMono.variable} h-full antialiased`}
      suppressHydrationWarning
    >
      <body className="min-h-screen bg-background text-foreground font-sans">
        {/* FOUC prevention : applique .dark sur <html> avant l'hydration React */}
        <script dangerouslySetInnerHTML={{ __html: NO_FOUC_SCRIPT }} />
        <RootShell>{children}</RootShell>
      </body>
    </html>
  );
}
